import { collectSearchKeys } from './collectSearchKeys.js'
import { filterAndCap } from './filterAndCap.js'
import { buildUserMentionSuggestions } from './mentionSuggestionsViewBody.js'

export function buildAgentMentionSuggestions(agents) {
  return (agents ?? []).map((a) => ({
    id: `agent:${a.id}`,
    kind: 'agent',
    label: a.name,
    subtitle: a.role ?? '',
    name: a.name,
    role: a.role,
    avatarSrc: a.avatarSrc ?? null,
    avatarAlt: a.avatarAlt ?? '',
    _keys: collectSearchKeys(a.name, '', a.role),
  }))
}

/**
 * @param {MentionSuggestion[]} items
 * @param {string} query
 */

/**
 * @param {{
 *   members?: Array<{ email: string, name: string }>,
 *   agents?: Array<{ id: string, name: string, role?: string }>,
 *   query?: string,
 * }} params
 * @returns {{ users: MentionSuggestion[], agents: MentionSuggestion[] }}
 */

export function getFilteredMentionSuggestions({ members = [], agents = [], query = '' }) {
  return {
    users: filterAndCap(buildUserMentionSuggestions(members), query),
    agents: filterAndCap(buildAgentMentionSuggestions(agents), query),
  }
}
